export default __webpack_public_path__ + "static/media/datadogDark.8f3ce3ee.svg";